"use strict";

class SuperLeadReportsController {
    constructor($scope, $window, $timeout, $localStorage, $parse, SSHttpService, SSUtilService, SSAppService, SSUserService, SSAlertService, SSConfirmationService) {

        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.$storage = $localStorage;
        self.$parse = $parse;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;

        self.BUYER_ENQUIRY_TYPE_GENERAL = SHOWSUITE.BUYER_ENQUIRY_TYPE_GENERAL;
        self.BUYER_ENQUIRY_TYPE_DEVELOPER = SHOWSUITE.BUYER_ENQUIRY_TYPE_DEVELOPER;
        self.BUYER_ENQUIRY_TYPE_BROKER = SHOWSUITE.BUYER_ENQUIRY_TYPE_BROKER;
        self.BUYER_ENQUIRY_TYPE_THIRD_PARTY = SHOWSUITE.BUYER_ENQUIRY_TYPE_THIRD_PARTY;
        self.BUYER_ENQUIRY_TYPE_INTERNAL = SHOWSUITE.BUYER_ENQUIRY_TYPE_INTERNAL;
        self.BUYER_ENQUIRY_TYPE_BUYER = SHOWSUITE.BUYER_ENQUIRY_TYPE_BUYER;

        self.BUYER_ENQUIRY_STATUS_CREATED = SHOWSUITE.BUYER_ENQUIRY_STATUS_CREATED;
        self.BUYER_ENQUIRY_STATUS_VERIFIED = SHOWSUITE.BUYER_ENQUIRY_STATUS_VERIFIED;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY;
        self.BUYER_ENQUIRY_STATUS_VIEWED = SHOWSUITE.BUYER_ENQUIRY_STATUS_VIEWED;
        self.BUYER_ENQUIRY_STATUS_BOOKED = SHOWSUITE.BUYER_ENQUIRY_STATUS_BOOKED;
        self.BUYER_ENQUIRY_STATUS_APPROVED = SHOWSUITE.BUYER_ENQUIRY_STATUS_APPROVED;
        self.BUYER_ENQUIRY_STATUS_EXERCISED = SHOWSUITE.BUYER_ENQUIRY_STATUS_EXERCISED;
        self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID = SHOWSUITE.BUYER_ENQUIRY_STATUS_COMMISSION_PAID;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.USER_STATUS_PENDING = SHOWSUITE.USER_STATUS_PENDING;
        self.USER_STATUS_ACTIVE = SHOWSUITE.USER_STATUS_ACTIVE;
        self.USER_STATUS_INACTIVE = SHOWSUITE.USER_STATUS_INACTIVE;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.initConstants();

        self.params = {};
        jQuery('.datepicker').datepicker({
            dateFormat: "yy-mm-dd"
        });

        $(document).ready(function () {
            $('.modal').on("hidden.bs.modal", function (e) { //fire on closing modal box
                if ($('.modal:visible').length) { // check whether parent modal is opend after child modal close
                    $('body').addClass('modal-open'); // if open mean length is 1 then add a bootstrap css class to body of the page
                }
            });
        });

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        if (!self.SSUserService.getUser()) {
          self.SSUserService.showLoginModal();
        }

        self.offset = 0;
        self.limit = 10;

        self.reportParams = {};

        self.getAllProperties();
        // Pass default status
        self.getLeads(self.BUYER_ENQUIRY_STATUS_EXERCISED);

        self.$timeout(function () {
            $('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "yy-mm-dd"
            });
        });
    }

    getLeads(status) {
        const self = this;

        self.searchFilter = status;

        self.leads = null;
        let url = 'sec/super/leads/get-commission-report-data';
        let params = {
            offset: self.offset,
            limit: self.limit,
            buyer_enquiry_status: status,
            property_id: self.reportParams.property_id,
            exercise_date_from: self.reportParams.from_date,
            exercise_date_to: self.reportParams.to_date,
            include: 'properties, units',
            send_total_count: 1
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }

            self.agent_total = 0;
            self.showsuite_total = 0;
            self.lead_total = 0;

            if (response.data.leads) {

                self.leads = response.data.leads;
                self.units = response.data.units;
                self.sales = response.data.sales;

                $.each(self.leads, function(index, lead){
                    let sale = self.sales.find(x => x.buyer_enquiry_id == lead.id);
                    lead.sale = null;
                    if(sale){
                        lead.sale = sale;
                        lead.sale_id = sale.id;
                        let agentCommission = lead.broker_commission_amount;
                        if(agentCommission && agentCommission != "--"){
                            let showsuiteCommission = lead.showsuite_commission_amount;
                            if (showsuiteCommission && showsuiteCommission != "--") {
                                self.showsuite_total += showsuiteCommission;
                                lead.showsuiteCommission = self.formatCommissionAmount(showsuiteCommission, lead.showsuite_commission_type, lead.showsuite_commission_value);    
                            }

                            let leadCommission = lead.amp_commission_amount;
                            if (leadCommission && leadCommission != "--") {
                                self.lead_total += leadCommission;
                                lead.leadCommission = self.formatCommissionAmount(leadCommission, lead.amp_commission_type, lead.amp_commission_value);    
                            }
                            self.agency_total += agentCommission;
                            lead.agentCommission = self.formatCommissionAmount(agentCommission);
                        }
                    } 
                });
            }
        });
    }

    showMoreLeads() {
        const self = this;

        self.limit = self.limit + 10
        self.getLeads();
    }

    toggleSelect() {
        const self = this;

        angular.forEach(self.leads, function (item) {
            item.same_date = event.target.checked;
        });
    }

    getAllProperties() {
        const self = this;

        let url = 'properties/customized';
        let params = {
            property_selected_fields: 'id, name, named_id',
            offset: 0,
            limit: 9999
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.properties) {
                self.properties = response.data.properties;
            }

            self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
        });
    }

    generatePdfReport() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to generate report',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                self.child = [];

                $("input[name='child[]']:checked").each(function () {
                    if ($(this).val() != '' && $(this).val() != ','){
                        self.child.push($(this).val());
                    }
                    // var val = $(this).val();
                    // jQuery.each(self.leads, function (i, e) {
                    //     if (typeof e != "undefined" && e.sale_id == val) {
                    //         self.leads.splice(i, 1);
                    //     }
                    // });
                });

                if (self.child.length == 0) {
                    self.SSAlertService.danger('Please select any/all record(s).');
                    return false;
                }

                if(typeof self.reportParams.from_date == 'undefined'){
                    self.reportParams.from_date = '';
                }
                if(typeof self.reportParams.to_date == 'undefined'){
                    self.reportParams.to_date = '';
                }

                let url = 'sec/super/leads/generate-commission-report?sale_ids='+ self.child;
                
                url = self.SSHttpService.getApiURL(url);

                window.open(url, '_blank');

                self.SSAlertService.success('PDF generated successfully.');
        });
    }

    getCommission(amount_type, amount_value, price){
        const self = this;

        if(!(amount_type && amount_value && price)){
            return '--';
        }

        let amount = amount_value;

        if(amount_type == self.VALUE_TYPE_PERCENTAGE && price){
            amount = (price * amount_value) / 100;
        }

        return amount;
    }

    formatCommissionAmount(amount, amount_type, amount_value){
        const self = this;

        if(!amount){
            return null;
        }

        let formattedAmount = self.SSUtilService.formatCurrency(amount);
        if(amount_type == self.VALUE_TYPE_PERCENTAGE && amount_value){
            formattedAmount += " ("+ amount_value +"%)";
        }

        return formattedAmount;
    }

    getPropertyObj(property_id) {
        const self = this;

        if (property_id && self.properties) {
            return self.properties.find(x => x.id == property_id);
        }

        return "";
    }

    getUnitObj(unit_id) {
        const self = this;

        if (unit_id && self.units) {
            return self.units.find(x => x.id == unit_id);
        }

        return "";
    }

    getBrokerObj(broker_id) {
        const self = this;

        if (broker_id && self.brokers) {
            return self.brokers.find(x => x.user_id == broker_id);
        }

        return "";
    }

    getAgencyObj(agency_id) {
        const self = this;

        if (agency_id && self.agencies) {
            return self.agencies.find(x => x.id == agency_id);
        }

        return "";
    }

    getLeadStatusName(status_id){
        const self = this;

        let name = '--';

        if(!status_id){
            return name;
        }

        let status = self.lead_statuses.find(x => x.id == status_id);
        if(status){
            name = status.name;
        }

        return name;
    }

    resetFilters(){
        const self = this;

        self.reportParams = {};
        self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
    }

    initConstants(){
        const self = this;

        self.lead_types = [
            {id: self.BUYER_ENQUIRY_TYPE_GENERAL, name: "Organic"},
            {id: self.BUYER_ENQUIRY_TYPE_DEVELOPER, name: "Developer"},
            {id: self.BUYER_ENQUIRY_TYPE_BROKER, name: "Broker"},
            {id: self.BUYER_ENQUIRY_TYPE_THIRD_PARTY, name: "Third Party"},
            {id: self.BUYER_ENQUIRY_TYPE_INTERNAL, name: "Internal"},
            {id: self.BUYER_ENQUIRY_TYPE_BUYER, name: "Referrals"},
        ];

        self.selective_lead_types = [
            {id: self.BUYER_ENQUIRY_TYPE_THIRD_PARTY, name: "Third Party"},
            {id: self.BUYER_ENQUIRY_TYPE_INTERNAL, name: "Internal"},
        ];

        self.commission_types = [
            {id: self.VALUE_TYPE_PERCENTAGE, name: "Percentage"},
            {id: self.VALUE_TYPE_AMOUNT, name: "Amount"},
        ];

        self.statuses = {};
        self.statuses[self.USER_STATUS_PENDING] = 'Pending';
        self.statuses[self.USER_STATUS_ACTIVE] = 'Active';
        self.statuses[self.USER_STATUS_INACTIVE] = 'In-active';

        self.buyer_types = [
            {id: self.BUYER_TYPE_INDIVIDUAL, name: "Individual"},
            {id: self.BUYER_TYPE_COMPANY, name: "Company"},
        ];

        self.lead_statuses = [
            {id: self.BUYER_ENQUIRY_STATUS_CREATED, name: "Created"},
            {id: self.BUYER_ENQUIRY_STATUS_VERIFIED, name: "Verified"},
            {id: self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY, name: "Sent to Team IC"},
            {id: self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT, name: "Assigned to Agent"},
            {id: self.BUYER_ENQUIRY_STATUS_VIEWED, name: "Viewed by Agent"},
            {id: self.BUYER_ENQUIRY_STATUS_BOOKED, name: "Booking Submitted"},
            {id: self.BUYER_ENQUIRY_STATUS_APPROVED, name: "Approved Conversion"},
            {id: self.BUYER_ENQUIRY_STATUS_EXERCISED, name: "Sale Exercised"},
            {id: self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID, name: "Commission Paid"},
        ];

    }

    markAsCommissionPaid() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to mark as Commission Paid',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                self.child = [];

                $("input[name='child[]']:checked").each(function () {
                    if ($(this).val() != '' && $(this).val() != ','){
                        self.child.push($(this).val());
                    }
                    // var val = $(this).val();
                    // jQuery.each(self.leads, function (i, e) {
                    //     if (typeof e != "undefined" && e.sale_id == val) {
                    //         self.leads.splice(i, 1);
                    //     }
                    // });
                });

                if (self.child.length == 0) {
                    self.SSAlertService.danger('Please select any/all record(s).');
                    return false;
                }

                if(typeof self.reportParams.from_date == 'undefined'){
                    self.reportParams.from_date = '';
                }
                if(typeof self.reportParams.to_date == 'undefined'){
                    self.reportParams.to_date = '';
                }

                let params = {
                    sale_ids: self.child.join()
                }

                let url = 'sec/super/leads/mark-commission-paid';

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.SSAlertService.success('Mark the sales as Commission Paid.');
                    //Refresh the page
                    self.$window.location.reload();
                });
        });
    }

}

SuperLeadReportsController.$inject = ['$scope', '$window', '$timeout', '$localStorage', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSAlertService', 'SSConfirmationService'];
app.controller('SuperLeadReportsController', SuperLeadReportsController);

